import { Component, OnInit } from '@angular/core';
import { GeographiesService } from 'projects/services/src/app/API/geographies.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { TrainingPartnerService } from 'projects/services/src/app/API/training-partner.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ValidationService } from 'projects/services/src/app/validation.service';

@Component({
	selector: 'app-tc-analtics',
	templateUrl: './tc-analtics.component.html',
	styleUrls: ['./tc-analtics.component.css']
})
export class TcAnalticsComponent implements OnInit {
	filterForm: FormGroup;
	trainingPartners: any;
	states: any;
	tcAnalyticsUrl: any;
	durationFields = {
		row: false,
		elements: [
			{
				placeholder: 'From Date',
				id: 'startDate'
			}, {
				placeholder: 'To Date',
				id: 'endDate'

			}
		],
		align: 6,
		labelDiv: 4,
		inputDiv: 8,
	};
	tcUrl: any;
	constructor(private fb: FormBuilder,
		private geographiesService: GeographiesService,
		public sanitizer: DomSanitizer) {
		this.tcUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`http://52.66.83.101/contentserver/services/embedUtil/dashboard/03aec49f-e011-4cb9-94be-3664a4e1338a?iFrame=true&isStatic=true&token=737e7f30-3e4f-41ca-8319-9d9106bffdcd`);
	}

	ngOnInit() {
		console.log(this.tcAnalyticsUrl, 'this.tcAnalyticsUrl');
		this.getStates();
		this.filterForm = this.fb.group({
			tpId: ['', []],
			state: ['', []],
			duration: ['', [ValidationService.dateDurationValidation()]],
		});
	}



	getStates() {
		this.geographiesService.getStates().subscribe(
			({ states }) => {
				this.states = states;
			},
			err => {
			}
		);
	}

	apply() {
		this.tcAnalyticsUrl = `http://52.66.83.101/contentserver/services/embedUtil/dashboard/03aec49f-e011-4cb9-94be-3664a4e1338a?iFrame=true&isStatic=true&token=737e7f30-3e4f-41ca-8319-9d9106bffdcd`;
		if (this.filterForm.get('state').value !== '' || this.filterForm.get('tpId').value) {
			this.tcAnalyticsUrl += `&hf={\\"dbhive_filters\\":{\\"Hfilters\\":[[`;
			if (this.filterForm.get('tpId').value !== '') {
				this.tcAnalyticsUrl += `\\"l:<b10184e9-cd0c-42f7-b3dc-ca0f905cbd4a>IN(%27${this.filterForm.get('tpId').value}%27)\\"`;
				if (this.filterForm.get('state').value !== '') {
					this.tcAnalyticsUrl += `,`;
				}
			}

			if (this.filterForm.get('state').value !== '') {
				this.tcAnalyticsUrl += `\\"l:<35c5229a-3598-4f41-a3a8-ee2f48b2f157>IN(%27${this.filterForm.get('state').value}%27)\\"`;
			}
			this.tcAnalyticsUrl += `]]}}`;
		}
		this.tcUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.tcAnalyticsUrl);
		console.log(this.tcAnalyticsUrl);
	}

}
